import React, {FC, useEffect, useState} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import SignaturePad from 'react-signature-pad-wrapper'
import Swal from 'sweetalert2'

import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {
  createCheckinService,
  createCheckoutService,
  uploadSignatureGuestService,
} from '../../../services/checking.service'
import {getTermsService} from '../../tyc/services'
import {render} from 'react-dom'
import {downloadPDFCheckInOutService} from '../../../services/booking.service'
import ReactPDFPrint from '../../checking/components/Print/ReactPDFPrint'
import {getSnackBarToast} from '../../../../../util/snackBar'

interface Props {
  prevStep: () => void
  nextStep: () => void
  stepper: any
  goToFirstStep: () => void
  goToStep: (index: number) => void
}

const FormStep3Parking: FC<Props> = ({prevStep, nextStep, stepper, goToFirstStep, goToStep}) => {
  const {
    // register,
    setValue,
    // watch,
    // control,
    // formState: {errors},
    // setError,
  } = useFormContext()

  const signaturePadRef = React.createRef<SignaturePad>()

  const [isChekingTyc, setIsChekingTyc] = useState(true)
  const [isLoadingResult, setIsLoadingResult] = useState(false)
  const [tycText, setTycText] = useState('')
  const [hasTyc, setHasTyC] = useState(false)
  const [isLoadingCheck, setIsLoadingCheck] = useState(false)

  const tipoDocumento_descripcion = useWatch({name: 'tipoDocumento_descripcion'})
  const numeroDocumento = useWatch({name: 'numeroDocumento'})
  const isGuest = useWatch({name: 'isGuest'})
  const aceptaTyC = useWatch({name: 'AceptaTyC'})
  const huespedId = useWatch({name: 'HuespedId'})
  const companiaId = useWatch({name: 'CompaniaId'})
  const clienteId = useWatch({name: 'ClienteId'})
  const siteId = useWatch({name: 'SiteId'})
  const reservaId = useWatch({name: 'ReservaId'})
  const camaId = useWatch({name: 'CamaId'})
  const bookingItem = useWatch({name: 'bookingItem'})
  const operationType = useWatch({name: 'operationType'})
  const reservaCamaId = useWatch({name: 'ReservaCamaId'})

  const handleReScan = () => {
    setValue('numeroDocumento', '')
    setValue('isGuest', false)
    setValue('errorCheck', false)
    setValue('AceptaTyC', false)
    setValue('HuespedId', '')
    setValue('CompaniaId', '')
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CamaId', '')
    setValue('ReservaId', '')
    setValue('bookingItem', {})
    goToStep(3)
  }

  const printPdf = (pdfUrl: any) => {
    const printWindow = window.open(pdfUrl, '_blank')
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.focus()
        printWindow.print()
      })
    }
  }

  const handleCheckIn = async () => {
    try {
      if (operationType === 'checkin') {
        setIsLoadingCheck(true)
        const {data: response} = await createCheckinService({
          ReservaId: reservaId,
          CamaId: camaId,
          HuespedId: huespedId,
        })
        if (response.error) {
          await setValue('errorCheck', true)
          getSnackBarToast(response.message, 'error')
          nextStep()
          setIsLoadingCheck(false)
          return
        }
        setIsLoadingCheck(false)
        nextStep()
        let dto = {
          reservaCamaId: reservaCamaId,
          tipo: 'IN',
          MotivoReimpresionId: '',
          Otros: '',
        }
        const resp = await downloadPDFCheckInOutService(dto)
        const blob = new Blob([resp.data], {type: 'application/pdf'})
        let url = window.URL.createObjectURL(blob)
        setTimeout(() => {
          printPdf(url)
        }, 1000)
        Swal.fire({
          title: 'Se ha realizado el check-in',
          html: `<div id="print_pdf">
              <button
                id='printButton'
                class='sdx_btn m-auto'
                type='button'
              >Imprimir Ticket Checkin</button>
            </div>`,
          icon: 'success',
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          didOpen: () => {
            const printButton = document.getElementById('printButton') as HTMLElement
            printButton.addEventListener('click', () => printPdf(url))
          },
        }).then(async (result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            Swal.close()
          }
        })
      } else {
        setIsLoadingCheck(true)
        const {data: response} = await createCheckoutService({
          ReservaId: reservaId,
          CamaId: camaId,
          HuespedId: huespedId,
        })

        if (response.error) {
          await setValue('errorCheck', true)
          getSnackBarToast(response.message, 'error')
          nextStep()
          setIsLoadingCheck(false)
          return
        }
        setIsLoadingCheck(false)
        nextStep()
        let dto = {
          reservaCamaId: reservaCamaId,
          tipo: 'OUT',
          MotivoReimpresionId: '',
          Otros: '',
        }
        const resp = await downloadPDFCheckInOutService(dto)
        const blob = new Blob([resp.data], {type: 'application/pdf'})
        let url = window.URL.createObjectURL(blob)
        setTimeout(() => {
          printPdf(url)
        }, 1000)
        Swal.fire({
          title: 'Se ha realizado el check-out',
          html: `<div id="print_pdf">
              <button
                id='printButton'
                class='sdx_btn m-auto'
                type='button'
              >Imprimir Ticket Checkout</button>
            </div>`,
          icon: 'success',
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          didOpen: () => {
            const printButton = document.getElementById('printButton') as HTMLElement
            printButton.addEventListener('click', () => printPdf(url))
          },
        }).then(async (result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            Swal.close()
          }
        })
      }
    } catch (error) {
      // Handle error
    }
  }

  const handleClearSignature = async () => {
    const signaturePad = signaturePadRef.current
    signaturePad?.clear()
  }

  const handleSaveSing = async () => {
    const signaturePad = signaturePadRef.current

    if (!signaturePad) {
      return
    }

    if (signaturePad.isEmpty()) {
      // eslint-disable-next-line no-alert
      Swal.fire('El huesped debe firmar primero.', '', 'warning')
    } else {
      setIsLoadingResult(true)
      let imageValue = signaturePad.toDataURL()
      const binaryData = atob(imageValue.replace('data:image/png;base64,', ''))
      const arrayBuffer = new ArrayBuffer(binaryData.length)
      const uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i)
      }
      //window.open(signaturePad.toDataURL());
      const blob = new Blob([uint8Array])
      const formData = new FormData()
      formData.append('file', blob, `Firma-${huespedId}.png`)

      const response = await uploadSignatureGuestService(formData, huespedId)
      setIsLoadingResult(false)
      if (!response.data.error) {
        handleCheckIn()
      } else {
        Swal.fire('No hemos podido guardar la firma', 'Intentalo nuevamente', 'error')
        //handleExit();
      }
    }
  }

  const handleExit = () => {
    goToFirstStep()
  }

  useEffect(() => {
    if (!aceptaTyC) {
      handlePaginationTerms()
    } else {
      setIsChekingTyc(false)
    }
  }, [])

  const handlePaginationTerms = async () => {
    const {data: response} = await getTermsService({
      CompaniaId: companiaId,
      ClienteId: clienteId,
      SiteId: siteId,
      pageNumber: 1,
      size: 10,
    })
    if (!response.error && response.data.length > 0 && response.data[0].TyC) {
      if (response.data[0].ModParqueoDeBuses) {
        setHasTyC(true)
        setTycText(response.data[0].TyC)
      } else {
        setHasTyC(false)
        // await setValue('AceptaTyC', true) // No se le permite firmar TyC
        //@todo("Poner Loading");
      }
    } else {
      setHasTyC(false)
    }
    setIsChekingTyc(false)
  }

  return (
    <div className='w-100'>
      {isChekingTyc ? (
        <div className='d-flex flex-column align-items-center mt-3'>
          <span className='indicator-progress' style={{display: 'block'}}>
            Verificando...
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        </div>
      ) : (
        <>
          {!aceptaTyC && isGuest && huespedId && hasTyc ? (
            <div className='d-flex justify-content-center flex-column align-items-center'>
              {tycText ? (
                <div className='d-flex flex-column align-items-center mt-3'>
                  {/*<span className='indicator-progress' style={{display: 'block'}}>*/}
                  {/*  Verificando...*/}
                  {/*  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>*/}
                  {/*</span>*/}
                  <h2>Terminos y condiciones</h2>
                  {/*<textarea className='form-control border-0 p-0 pe-10 resize-none min-h-25px'*/}
                  {/*          data-kt-autosize='true'*/}
                  {/*          disabled={true}*/}
                  {/*          rows={20}*/}
                  {/*          placeholder='Reply..'>{ tycText }</textarea>*/}
                  <div
                    className={
                      'form-control border-1 p-3 justify-content-center resize-none h-25 overflow-scroll'
                    }
                    dangerouslySetInnerHTML={{__html: tycText}}
                  ></div>
                  <h4 className={'mt-3'}>Firma:</h4>
                  <div className='border mt-2'>
                    <SignaturePad redrawOnResize ref={signaturePadRef} width={500} height={150} />
                  </div>
                  <div className={'mt-3'}>
                    {' '}
                    (
                    <button
                      onClick={handleClearSignature}
                      type={'button'}
                      className={'btn btn-link'}
                    >
                      Borrar firma
                    </button>
                    ){' '}
                  </div>
                  <div className='d-flex flex-stack pt-15'>
                    <div className='mr-2'>
                      <button
                        type='button'
                        className='btn btn-lg btn-light-primary me-3'
                        onClick={handleSaveSing}
                        disabled={isLoadingResult}
                      >
                        {!isLoadingResult && <span className='indicator-label'>Aceptar</span>}
                        {isLoadingResult && (
                          <span className='indicator-progress' style={{display: 'block'}}>
                            Enviando...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                      <button
                        type='button'
                        className='btn btn-lg btn-light-secondary me-3'
                        onClick={handleReScan}
                      >
                        Reescanear
                      </button>
                      <button
                        type='button'
                        className='btn btn-lg btn-light-secondary me-3'
                        onClick={handleExit}
                      >
                        Salir
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='d-flex flex-column align-items-center mt-3'>
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Verificando...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                </div>
              )}
            </div>
          ) : (
            <div className='d-flex justify-content-center flex-column align-items-center'>
              {!isGuest || !!!huespedId ? (
                <div className='d-flex justify-content-center flex-column align-items-center'>
                  <div>
                    <img alt='Exito' src={toAbsoluteUrl('/media/logos/close.png')} />
                  </div>
                  <div className='d-flex flex-column align-items-center mt-3'>
                    <div className='fs-1 fw-bolder'>No se encontraron reservas activas</div>
                  </div>
                </div>
              ) : (
                <div className='row'>
                  <div className=''>
                    <div>
                      <span className='fw-bold fs-6'>Tipo de Documento: </span>
                      <span className='fs-6'>{tipoDocumento_descripcion}</span>
                    </div>
                    <div className='mb-5'>
                      <span className='fw-bold fs-6'>Numero de Documento: </span>
                      <span className='fs-6'>{numeroDocumento}</span>
                    </div>
                    <div className='fw-bold fs-5 mb-5'>Detalles de Reserva</div>
                    <div>
                      <span className='fw-bold fs-6'>Nombres: </span>
                      <span className='fs-6'>{bookingItem?.HuespedDescripcion}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Empresa: </span>
                      <span className='fs-6'>{bookingItem?.Compania}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Site: </span>
                      <span className='fs-6'>{bookingItem?.Site}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Campamento: </span>
                      <span className='fs-6'>{bookingItem?.Campamento}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Módulo: </span>
                      <span className='fs-6'>{bookingItem?.Modulo}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Piso: </span>
                      <span className='fs-6'>{bookingItem?.Nivel_descripcion}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Habitación: </span>
                      <span className='fs-6'>{bookingItem?.Habitacion}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Cama: </span>
                      <span className='fs-6'>{bookingItem?.CodigoCama}</span>
                    </div>
                  </div>
                </div>
              )}
              <div className='d-flex flex-stack pt-15'>
                <div className='mr-2'>
                  {!isGuest || !!!huespedId ? (
                    <></>
                  ) : (
                    <>
                      <button
                        type='button'
                        className='btn btn-lg btn-light-primary me-3'
                        onClick={handleCheckIn}
                        disabled={isLoadingCheck}
                      >
                        {!isLoadingCheck && <span className='indicator-label'>Confirmar</span>}
                        {isLoadingCheck && (
                          <span className='indicator-progress' style={{display: 'block'}}>
                            Confirmar...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </>
                  )}
                  <button
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    onClick={handleReScan}
                    disabled={isLoadingCheck}
                  >
                    Reescanear
                  </button>
                  <button
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    onClick={handleExit}
                    disabled={isLoadingCheck}
                  >
                    Salir
                  </button>
                  {/* {!isGuest || !!!huespedId ? (
              <>
                <button
                  type='button'
                  className='btn btn-lg btn-light-primary me-3'
                  onClick={handleExit}
                >
                  Salir
                </button>
              </>
            ) : (
              <></>
            )} */}
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </div>
  )
}

export {FormStep3Parking}
